module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ipoint"
  }, [_c('p', {
    staticClass: "remaining"
  }, [_vm._v(_vm._s(_vm.$t('user_center_iPoint_Remaining')) + ": " + _vm._s(_vm.ipointCount))]), _vm._v(" "), _c('div', {
    staticClass: "tabs tabs-ipoint"
  }, [_c('topUp')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b3651c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/iPoint.vue
// module id = 786
// module chunks = 0